import React from 'react'

const socials = [
  { label: 'LinkedIn',  icon: 'ri-linkedin-box-line', href: 'https://www.linkedin.com/in/hhphu/'    },
  { label: 'X',         icon: 'ri-twitter-x-line',    href: 'https://twitter.com/hhphu'             },
  { label: 'Instagram', icon: 'ri-instagram-line',    href: 'https://www.instagram.com/hackingphu/' },
]

export default function Contact() {
  return (
    <div className="py-24">
      <div className="text-center mb-12">
        <p className="section-label">{"// contact"}</p>
        <h2 className="text-[1.5rem] sm:text-[1.75rem] font-bold text-title mb-2">Let's Build Something</h2>
        <p className="text-sm text-muted">
          Have a project in mind? I'm always open to discussing new opportunities.
        </p>
      </div>

      <div className="card max-w-xl mx-auto p-10 flex flex-col items-center gap-6">
        <a
          href="mailto:harry.hphu@gmail.com"
          className="flex items-center gap-2.5 text-muted hover:text-title transition-colors"
        >
          <i className="ri-mail-line text-lg text-accent"></i>
          <span className="font-mono text-[0.938rem]">harry.hphu@gmail.com</span>
        </a>

        <div className="flex items-center gap-3 flex-wrap justify-center">
          {socials.map(({ label, icon, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-card-border
                         text-muted text-sm hover:text-title hover:border-accent transition-colors"
            >
              <i className={`${icon} text-base`}></i>
              {label}
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}
